import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from "ng2-translate";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FirebaseListObservable,
  AngularFireDatabase
} from 'angularfire2/database-deprecated';
import { Subscription } from 'rxjs';
import { MediaMatcher } from '@angular/cdk/layout';
import { UserService } from '../../_services/user.service';
import { Observable } from 'rxjs/Observable';
import { MatDialog } from '@angular/material';
import { SaveMessageComponent } from '../../directive/save-message/save-message.component';
import { Http } from '@angular/http';
import { AngularFirestore } from 'angularfire2/firestore';
@Component({
  selector: 'app-landing-page2',
  templateUrl: './landing-page2.component.html',
  styleUrls: ['./landing-page2.component.css']
})
export class LandingPage2Component implements OnInit {
  private subscription: Subscription = new Subscription();
  brandName: string;
  brandRate: FirebaseListObservable<any[]>;
  brand: any;
  uniqueName: string;
  userId = this.userService.getUid();
  user: any;
  brandCategories: FirebaseListObservable<any[]>;
  model: any;
  mode: boolean;
  averageRate: any;
  categoryButtonText: any;
  mobileQuery: any;
  private _mobileQueryListener: () => void;
  constructor(private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    public translate: TranslateService,
    private media: MediaMatcher,
    private afs: AngularFirestore,
    private dialog: MatDialog,
    private http: Http,
    private cd: ChangeDetectorRef,
    private cdr: ChangeDetectorRef) {
    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user;
    }));
    this.mobileQuery = this.media.matchMedia('(max-width: 1024px)');
    this._mobileQueryListener = () => this.cd.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.subscription.unsubscribe();
  }

  ngOnInit() {

  }
  getIpAdress(): Observable<any> {
    return this.http.get("https://api.bigadvice.com/helper/ip")
      .map(data => data.json());
  }

  joinUs(email) {
    if (email.replace(/\s/g, '') == '') {
      this.dialog.open(SaveMessageComponent, {
        width: '400px',
        data: {
          message: "E-posta adresini yazmalısın!",
          type: "update"
        }
      });
      return;
    }
    this.getIpAdress().subscribe(data => {
      this.afs.collection('newsLetter').add({
        email: email,
        modifyDate: Date.now(),
        ipAdress: data
      }).then(() => {
        this.dialog.open(SaveMessageComponent, {
          width: '400px',
          data: {
            message: "Bilgilerin iletilmiştir, teşekkürler.",
            type: "update"
          }
        });
      });
    });

  }


  ngAfterViewInit() {
    this.cdr.detectChanges();
  }


}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/landing-page2/landing-page2.component.ts